/* pages/NewsDetail.js */
import React, { useEffect, useState, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa';
import '../styles/NewsDetail.css';

const API_BASE = process.env.REACT_APP_API_BASE || "";

export default function NewsDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [news, setNews] = useState(null);
  const [error, setError] = useState(false);

  const applyLazyLoading = (htmlContent) => {
    if (!htmlContent) return "";
    return htmlContent.replace(/<img /g, '<img loading="lazy" ');
  };

  const getLangData = (item, field) => {
    const lang = (i18n.language || 'KR').toLowerCase();
    return item[`${field}_${lang}`] || item[`${field}_kr`] || "";
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API_BASE}/api/news_detail.php?id=${id}`)
        .then(res => {
        if (!res.ok) throw new Error('News not found');
        return res.json();
        })
        .then(data => {
            setNews(data);
            setError(false);
        })
        .catch(err => {
            console.error(err);
            setError(true);
        });
    }, [id]);

    const processedContent = useMemo(() => {
      if (!news) return "";
      const rawHtml = getLangData(news, 'content');
      return applyLazyLoading(rawHtml);
    }, [news, i18n.language]);

  if (error) {
    return (
      <div className="sub-page-container error-page">
        <p>존재하지 않는 기사입니다.</p>
        <button onClick={() => navigate('/news')}>목록으로 돌아가기</button>
      </div>
    );
  }

  const title = news ? getLangData(news, 'title') : "Loading...";
  const pageTitle = news ? `${title} | 배우 한지우 뉴스` : "배우 한지우 뉴스";
  const ogImage = news?.thumbnail || "https://hanjiwoo.com/og/og-home.jpg";
  const desc = news ? (getLangData(news, 'title') || '배우 한지우의 최신 소식을 확인하세요.') : '배우 한지우의 최신 소식을 확인하세요.';

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={desc} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={`https://hanjiwoo.com/news/${id}`} />
        <meta property="og:image" content={ogImage} />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content={ogImage} />

        <link rel="canonical" href={`https://hanjiwoo.com/news/${id}`} />
      </Helmet>
      
      {!news ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="sub-page-container news-detail-page">
            <article className="news-article">
                <header className="article-header">
                    <span className="article-date">{news.date?.replace(/-/g, '.')}</span>
                    <h1 className="article-title">{title}</h1>
                    <div className="article-divider"></div>
                </header>
                
                <div className="article-content ql-editor" dangerouslySetInnerHTML={{ __html: processedContent }} />
                
                <footer className="article-footer">
                    <button className="back-btn" onClick={() => navigate('/news')}>
                        <FaArrowLeft size={14} className="back-icon" />
                    {/* {t('common_list') || 'LIST'} */}
                    </button>
                </footer>
            </article>
        </div>
      )}
    </>
  );
}